import styled from 'styled-components';
import { spacing, palette } from '@cbhq/cds-web/tokens';
import { ANALYTICS_KEY } from '../../constants.js';
import '../../ui/Div/index.js';
import '../../ui/Link/index.js';
import { Trapdoor } from './Trapdoor.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Link } from '../../ui/Link/Link.js';
function Navlink({
  url,
  label = '',
  trapdoorLinks = [],
  productLink,
  activeTab,
  setActiveTab,
  hasBanner,
  color = 'foreground'
}) {
  const isDuplicateUrlPath = typeof window !== 'undefined' && window.location.pathname === url;

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop, @typescript-eslint/no-explicit-any -- TODO Fix this
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      label && setActiveTab(label);
    }
    if (event.key === 'Escape') {
      setActiveTab('');
    }
  };
  if (url && isDuplicateUrlPath) {
    return /*#__PURE__*/jsx(Div, {
      css: {
        button: {
          height: '100%'
        }
      },
      children: /*#__PURE__*/jsx(Link, {
        variant: "label1",
        href: url,
        onKeyDown: handleKeyPress,
        "data-qa": ANALYTICS_KEY.NavLinkButton,
        children: /*#__PURE__*/jsx(StyledLink, {
          $hasUrl: !!url,
          $isActive: activeTab === label,
          position: "relative",
          alignItems: "center",
          height: "100%",
          color: color
          // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
          ,

          onMouseEnter: () => {
            label && setActiveTab(label);
          },
          children: label
        })
      })
    });
  }
  if (url) {
    return /*#__PURE__*/jsx(Div, {
      css: {
        button: {
          height: '100%'
        }
      },
      children: /*#__PURE__*/jsx(Link, {
        href: url,
        variant: "label1",
        onKeyDown: handleKeyPress,
        "data-qa": ANALYTICS_KEY.NavLinkButton,
        children: /*#__PURE__*/jsx(StyledLink, {
          $hasUrl: !!url,
          $isActive: activeTab === label,
          position: "relative",
          alignItems: "center",
          height: "100%",
          color: color
          // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
          ,

          onMouseEnter: () => {
            label && setActiveTab(label);
          },
          children: label
        })
      })
    });
  }
  return /*#__PURE__*/jsxs(Link, {
    variant: "label1",
    color: "foreground",
    onKeyDown: handleKeyPress,
    "data-qa": ANALYTICS_KEY.NavLinkButton,
    children: [/*#__PURE__*/jsx(StyledLink, {
      $hasUrl: !!url,
      $isActive: activeTab === label,
      position: "relative",
      alignItems: "center",
      height: "100%",
      color: color
      // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
      ,

      onMouseEnter: () => {
        label && setActiveTab(label);
      },
      children: label
    }), trapdoorLinks.length > 0 && /*#__PURE__*/jsx(Trapdoor, {
      isActive: activeTab === label,
      links: trapdoorLinks,
      hasBanner: hasBanner,
      productLink: productLink
    })]
  });
}
const StyledLink = styled(Div)`
  width: 100%;
  text-align: center;
  margin: auto;
  height: 100%;
  padding: 0 ${spacing[2]};
  cursor: ${({
  $hasUrl
}) => $hasUrl ? 'cursor' : 'initial'};
  ${({
  $isActive
}) => {
  return $isActive && `
        &:before {
          position: absolute;
          padding: 0 ${spacing[2]};
          top: calc(100% - 3px);
          width: calc(100% - 32px);
          height: 4px;
          background: ${palette.primary};
          display: inline-block;
          content: '';
          cursor: inherit;
        }
      `;
}};
`;
export { Navlink };
//# sourceMappingURL=Navlink.js.map
